import { Module } from 'vuex';
import {
  action,
  actionCreatorFactory,
  combineAction,
  combineMutation,
  mutation,
} from 'vuex-typescript-fsa/lib';
import { RootState } from '@/store';

export const namespace = 'settings';
const actionCreator = actionCreatorFactory(namespace);
export const SetApiBasePath = actionCreator<{ path: string }>(
  'SET_API_BASE_PATH'
);

export interface State {
  apiBasePath: string;
}

const initialState = (): State => {
  return { apiBasePath: null };
};

export const module: Module<State, RootState> = {
  namespaced: true,
  state: initialState,
  actions: combineAction(
    action(SetApiBasePath, function(context, action) {
      context.commit(SetApiBasePath(action.payload));
    })
  ),
  mutations: combineMutation(
    mutation(SetApiBasePath, (state, action) => {
      state.apiBasePath = action.payload.path;
    })
  ),
  getters: {
    apiBasePath: state => state.apiBasePath,
  },
};
